import { render, staticRenderFns } from "./InventoryPrintModal.vue?vue&type=template&id=35a45b2e"
import script from "./InventoryPrintModal.vue?vue&type=script&lang=ts"
export * from "./InventoryPrintModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports